import MomentDateHelper from "./MomentDateHelper";

export default date => {
  return new MomentDateHelper(date);
};
